<mat-icon
  class="ui-icon"
  [ngClass]="getIconClasses()"
  [color]="color"
  [svgIcon]="name"
/>